import React from 'react';
import classNames from 'classnames';

import ProgressNavBarLink, { ProgressNavBarLinkProps } from './link';

import './pill-bar.scss';

interface Link {
    show: boolean;
    id: string;
}

interface Props extends ProgressNavBarLinkProps {
    links: Array<string | Link>;
}

const ProgressNavBar = (props: Props) => (
    <div role="navigation" className={classNames( 'main-nav', 'pill-bar' )}>
        <ul role="menu">
            { props.links.map( ( link, i ) => {
                if ( typeof link === 'string' ) {
                    return <ProgressNavBarLink key={i} {...props} id={link} />;
                } else if ( link.show ) {
                    return <ProgressNavBarLink key={i} {...props} id={link.id} />;
                }
            } ) }
        </ul>
    </div>
);
export default ProgressNavBar;
